export default __webpack_public_path__ + "static/media/Inventory-icon.0683e8c7.svg";